"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-float"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dompurify = _interopRequireDefault(require("dompurify"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_sanofi/cssConstants.js"));

var _DrupalVideoNugget = _interopRequireDefault(require("./DrupalVideoNugget.scss"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _CordovaFileHelper = _interopRequireWildcard(require("../../../../helpers/CordovaFileHelper"));

var _FileTransferWrapper = _interopRequireDefault(require("../../../../cordovaPluginWrappers/FileTransferWrapper"));

var _TimeoutHelper = require("../../../../helpers/TimeoutHelper");

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _StringHelper = _interopRequireDefault(require("../../../../helpers/StringHelper"));

var _WatchedSequences = _interopRequireDefault(require("./WatchedSequences"));

var _VideoNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/VideoNugget"));

var _DrupalVideoNuggetStrings = require("./DrupalVideoNuggetStrings");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _UrlHelper = _interopRequireDefault(require("../../../../helpers/UrlHelper"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _KESI2Helper = require("../../../../KESI2/KESI2Helper");

var _Video = _interopRequireDefault(require("../../Video/Video"));

var _HttpRequest = require("../../../../utils/HttpRequest");

var _VideoActionManager = _interopRequireWildcard(require("./VideoActionManager"));

var _DownloadHelper = _interopRequireDefault(require("../../../../helpers/DownloadHelper"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _FeedbackService = require("../../../../KESI2/Services/FeedbackService");

var _ArrayHelper = require("../../../../helpers/ArrayHelper");

var _MuiAlertHelper = require("../../../../helpers/MuiAlertHelper");

var _PlayCircleFilled = _interopRequireDefault(require("@material-ui/icons/PlayCircleFilled"));

var _Image = _interopRequireDefault(require("../../Image/Image"));

var _icons = require("@material-ui/icons");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var FULLSCREEN_ENTER_ICON = require('./assets/fullscreen_enter.svg');

var DOWNLOAD_ICON = require('./assets/download_icon.png');

var SHARE_ICON = require('./assets/share_icon.png');

var DELETE_ICON = require('./assets/delete_icon.png');

var ERROR_ICON = require('./assets/error.png');

var M3U8_WAITING_TIME = 1500; // in ms

var WIDE_ROW_THRESHOLD = 650; // if you change it here, change it in the css, too

var DOM_PREFIX = 'videoContainer_';
var TRACK_KINDS = {
  CAPTIONS: 'captions'
};

var DrupalVideoNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalVideoNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalVideoNugget);

  function DrupalVideoNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalVideoNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkEnterKey", function (event) {
      if (event.key === 'Enter') {
        var el = document.activeElement;

        if (el) {
          if (el.id === 'playBtn') {
            _this.setState({
              videoIsPlaying: true
            });
          }
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getCorrectVideoUrl", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(m3u8) {
        var parts, filename, mediaId, infoUrl, videoRequestResult, sources, tracks, optimalLongSide, longSideDiff, optimalMp4File, width, i, l, description;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                parts = _UrlHelper["default"].parseURL(m3u8);
                filename = parts.pathname.split('/').pop();
                mediaId = filename.substring(0, filename.indexOf('.'));
                infoUrl = parts.protocol + '//cdn.jwplayer.com/v2/media/' + mediaId;
                _context.next = 7;
                return (0, _HttpRequest.httpGetExtern)(infoUrl, {}, null, null, null, null);

              case 7:
                videoRequestResult = _context.sent;

                if (!(videoRequestResult.status === 200 && videoRequestResult.data)) {
                  _context.next = 31;
                  break;
                }

                if (_this.errorTimeout) _this.errorTimeout.invalidate();
                sources = videoRequestResult.data.playlist[0].sources;
                tracks = videoRequestResult.data.playlist[0].tracks;
                tracks.forEach(function (track) {
                  if (track && track.kind && track.kind === TRACK_KINDS.CAPTIONS) {
                    _this.setState({
                      subtitleUrl: track.file
                    });
                  }
                });
                optimalLongSide = null;
                longSideDiff = null;
                optimalMp4File = null;
                width = Math.max(window.innerHeight, window.innerWidth) || 640;
                i = 0, l = sources.length;

              case 18:
                if (!(i < l)) {
                  _context.next = 28;
                  break;
                }

                description = sources[i];

                if (!(description.label === 'Passthrough')) {
                  _context.next = 22;
                  break;
                }

                return _context.abrupt("continue", 25);

              case 22:
                if (description.hasOwnProperty('width')) {
                  _context.next = 24;
                  break;
                }

                return _context.abrupt("continue", 25);

              case 24:
                if (!optimalLongSide || Math.abs(width - description.width) < longSideDiff) {
                  optimalMp4File = description.file;
                  optimalLongSide = description.width;
                  longSideDiff = Math.abs(width - optimalLongSide);
                }

              case 25:
                i++;
                _context.next = 18;
                break;

              case 28:
                if (optimalMp4File) _this.setState({
                  sanitizedSrc: optimalMp4File,
                  playsM3u8: false
                });
                _context.next = 32;
                break;

              case 31:
                console.log('ERROR', 'DrupalVideoNugget.getCorrectVideoUrl', 'status != 200', videoRequestResult);

              case 32:
                _context.next = 37;
                break;

              case 34:
                _context.prev = 34;
                _context.t0 = _context["catch"](0);
                console.log('ERROR', 'Drupal.VideoNugget.getCorrectVideoUrl', _context.t0);

              case 37:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 34]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "deleteVideo", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _CordovaFileHelper["default"].deleteFile(_this.shortFilename, _CordovaFileHelper.LOCAL_FILENAMES.VIDEO_FOLDER);

            case 3:
              _this.setState({
                offlineAvailable: false
              });

              return _context2.abrupt("return", _promise["default"].resolve());

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.error("error deleting file ".concat(_this.shortFilename, ": "), _context2.t0);
              return _context2.abrupt("return", _promise["default"].reject(new Error('cant delete file')));

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "downloadVideo", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var nugget, onProgress, downloadableSrc, offlineAvailable;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this.isDownloading) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", _promise["default"].reject(new Error('already downloading')));

            case 2:
              _this.isDownloading = true;
              _context3.prev = 3;
              nugget = _this.getNugget();

              if (nugget.downloadable) {
                _context3.next = 7;
                break;
              }

              return _context3.abrupt("return", _promise["default"].reject(new Error('Download not allowed')));

            case 7:
              onProgress = function onProgress(evt) {
                if (!evt || !evt.loaded || !evt.total) {
                  _this.setProgress(-1);

                  return;
                }

                var progressPercent = Math.floor(evt.loaded / evt.total * 100);

                _this.setProgress(progressPercent);
              };

              _this.setProgress(0);

              _context3.next = 11;
              return _DownloadHelper["default"].getRedirectedUrl(_this.state.sanitizedSrc || nugget.src);

            case 11:
              downloadableSrc = _context3.sent;
              if (window.CookiesPlugin) window.CookiesPlugin.deleteCookiesFromHost('jwsrv.com');else console.warn("No CookiesPlugin found so we can't delete the JW videos. Switching between streaming and downloading may not work then.");
              _context3.next = 15;
              return new _FileTransferWrapper["default"]().downloadWithJS(downloadableSrc, _this.shortFilename, _CordovaFileHelper.LOCAL_FILENAMES.VIDEO_FOLDER, onProgress, true, function (cancelFn) {
                return _this.cancelVideoDownloadFn = cancelFn;
              });

            case 15:
              _context3.next = 17;
              return _this.checkIsOfflineAvailable();

            case 17:
              offlineAvailable = _context3.sent;

              if (!offlineAvailable) {
                console.error('Something went wrong on video download though download seems to be completed');
              }

              _context3.next = 24;
              break;

            case 21:
              _context3.prev = 21;
              _context3.t0 = _context3["catch"](3);
              console.error('error downloading video', _context3.t0);

            case 24:
              _this.isDownloading = false;

              _this.forceUpdate();

              return _context3.abrupt("return", _promise["default"].resolve());

            case 27:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 21]]);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onLowPowerModeEnabled", function () {
      _this.lowPowerModeTimeoutHandle = setTimeout(function () {
        (0, _MuiAlertHelper.showAlertWithOptions)({
          message: (0, _DrupalVideoNuggetStrings.getString)('POWER_MODE_ENABLED'),
          title: (0, _DrupalVideoNuggetStrings.getString)('WATCH_OUT'),
          size: 'large',
          showCloseButton: true
        });

        _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.LOW_POWER_MODE_ALERT_TIMESTAMP, (0, _now["default"])(), false);
      }, 1000);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onError", function (error) {
      return _this.state.playsM3u8 && _this.state.sanitizedSrc && _this.setState({
        playsM3u8: false
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onMetadataLoaded", function () {
      if (_this.errorTimeout) _this.errorTimeout.invalidate();
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onPlay", function () {
      if (!_this.props.inSwipeContainer) _this.props.markAsRead(_this.props.id);

      _this.setState({
        isPlaying: true
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onPause", function () {
      _this.setState({
        isPlaying: false
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setIsOffline", function () {
      _this.setState({
        isOnline: false
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setIsOnline", function () {
      _this.setState({
        isOnline: true
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "toggleFullscreen", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var onFullscreenLeave;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (_this.videoElement) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              if (!_this.videoElement.requestFullscreen()) {
                _context4.next = 11;
                break;
              }

              _this.setState({
                fullscreen: true
              });

              _this.videoElement.requestFullscreen();

              if (!window.screen.orientation) {
                _context4.next = 8;
                break;
              }

              _context4.next = 8;
              return window.screen.orientation.lock('landscape');

            case 8:
              onFullscreenLeave = function onFullscreenLeave() {
                if (document.fullscreenEnabled || document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen) {
                  _this.videoElement.onfullscreenchange = null;

                  _this.setState({
                    fullscreen: false
                  });

                  if (window.screen.orientation) {
                    if (_config["default"].onlyPortrait) window.screen.orientation.lock('portrait');else window.screen.orientation.unlock();
                  }
                }
              };

              setTimeout(function () {
                return _this.videoElement.onfullscreenchange = onFullscreenLeave;
              }, 500);
              setTimeout(function () {
                return onFullscreenLeave;
              }, 3000);

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setLike", function () {
      var likes = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_LIKES) || [];
      var likeIndex = likes.indexOf(_this.props.id);

      if (likeIndex < 0) {
        likes.push(_this.props.id);
        (0, _FeedbackService.pushLikeMessage)(_this.props.id, 'add', _config["default"].rootId);
      } else {
        (0, _ArrayHelper.removeElementAtPosition)(likes, likeIndex);
        (0, _FeedbackService.pushLikeMessage)(_this.props.id, 'remove', _config["default"].rootId);
      }

      _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_LIKES, likes);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "toogleTranscript", function () {
      return _this.setState({
        transcriptOpen: !_this.state.transcriptOpen
      });
    });
    _this.state = _objectSpread({
      // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor
      playsM3u8: true,
      sanitizedM3u8: null,
      sanitizedSrc: null,
      isOnline: true,
      offlineAvailable: false,
      downloadProgress: -1,
      localSrc: null,
      waitingForActivation: false,
      fullscreen: false,
      videoIsPlaying: false,
      subtitleUrl: null,
      transcriptOpen: false
    }, _this.state);
    _this.videoElement = null;
    _this.shortFilename = null;
    _this.domId = _StringHelper["default"].createShortId();
    _this.watchedSequences = null; // will be set after mount

    _this.videoActionManager = null;
    _this.nextDownloadProgressToSet = null;
    _this.progressTimeout = null;
    _this.isDownloading = false;
    _this.errorTimeout = null;
    _this.active = true;

    _this.props.registerNugget(_this.props.id, _VideoNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalVideoNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES, _DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, _DataStore.DATA_STORE_PATHS.LOW_POWER_MODE_ALERT_TIMESTAMP]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalVideoNugget, [{
    key: "_setSequenceWatcher",
    value: function _setSequenceWatcher() {
      if (!this.videoElement) {
        this.videoElement = document.getElementById(this.domId);

        if (this.videoElement && this.props.action) {
          this.videoActionManager = new _VideoActionManager["default"](this.videoElement);
          this.executeAction();
        }
      }

      if (this.videoElement && !this.watchedSequences) {
        this.watchedSequences = new _WatchedSequences["default"](this.getNugget(), this.videoElement);
        this.videoElement.addEventListener('play', this.onPlay);
        this.videoElement.addEventListener('pause', this.onPause);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.registerNuggetPosition(this.props.id, _VideoNugget["default"].CLASS, this.getDomId());
      var nugget = this.getNugget();
      this.shortFilename = "".concat(nugget.id).concat(_CordovaFileHelper.FILE_POSTFIXES.VIDEO_MP4);

      this._setSequenceWatcher();

      this.initListeners(); // start error timer

      this.errorTimeout = new _TimeoutHelper.InvalidatableTimeout(M3U8_WAITING_TIME);

      var sanitizedM3u8 = this._correctM3u8(_dompurify["default"].sanitize(nugget.m3u8, {
        ALLOW_UNKNOWN_PROTOCOLS: true
      }));

      setTimeout(function () {
        var isOnline = _DeviceInfoHelper["default"].isBrowser() || window.navigator.connection && window.navigator.connection.type && window.navigator.connection.type !== window.Connection.NONE;

        _this2.setState({
          sanitizedM3u8: sanitizedM3u8,
          playsM3u8: sanitizedM3u8 !== null,
          isOnline: isOnline
        });

        _this2.errorTimeout.wait().then(function () {
          _this2.onError('waiting time for metadata is up');
        })["catch"](function () {
          console.log('DrupalVideoNugget.errorTimeout stopped');
        });

        _this2.getCorrectVideoUrl(sanitizedM3u8);

        if (_config["default"].videosDownloadable) {
          _this2.checkIsOfflineAvailable();
        }
      }, 10);
      if (this.props.inGalleryContainer && this.props.galleryContainerIndex === 0 || !this.props.inGalleryContainer) this.showLowPowerModeAlertIfNeeded();
      if (this.props.inListContainer) this.props.setBackButtonFunc(this.props.goUpFunc);
      if (_DeviceInfoHelper["default"].isBrowser()) window.addEventListener('keypress', function (event) {
        return _this2.checkEnterKey(event);
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalVideoNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var nugget = this.state.content[prevProps.id];
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join('!')), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join('!')] : nugget.active;

      if (this.state.waitingForActivation && active !== this.active) {
        this.setState({
          waitingForActivation: false
        });
      }

      this._setSequenceWatcher();

      if (this.videoElement && prevProps.action !== this.props.action) {
        this.executeAction();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalVideoNugget.prototype), "componentWillUnmount", this).call(this);
      this.removeListeners();
      if (this.videoActionManager) this.videoActionManager.cleanUp();
      if (this.lowPowerModeTimeoutHandle) clearTimeout(this.lowPowerModeTimeoutHandle);
      if (_DeviceInfoHelper["default"].isBrowser()) window.removeEventListener('keypress', function (event) {
        return _this3.checkEnterKey(event);
      });
    }
  }, {
    key: "showLowPowerModeAlertIfNeeded",
    value: function showLowPowerModeAlertIfNeeded() {
      if (_DeviceInfoHelper["default"].isBrowser()) return;

      var lastTimestmap = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.LOW_POWER_MODE_ALERT_TIMESTAMP);

      var newTimeStamp = (0, _now["default"])();
      var interval = 30000;

      if (lastTimestmap) {
        if (newTimeStamp - interval > lastTimestmap) {
          console.log('SHOWING ALERT because 30 secs have passed');

          if (window.cordova && window.cordova.plugins && window.cordova.plugins.equeoCheckLowPowerMode) {
            window.cordova.plugins.equeoCheckLowPowerMode.check(this.onLowPowerModeEnabled);
          }
        }
      } else {
        console.log('SHOWING ALERT because it hasnt been shown yet');

        if (window.cordova && window.cordova.plugins && window.cordova.plugins.equeoCheckLowPowerMode) {
          window.cordova.plugins.equeoCheckLowPowerMode.check(this.onLowPowerModeEnabled);
        }
      }
    }
  }, {
    key: "executeAction",
    value: function executeAction() {
      if (this.props.action.startsWith('startvideo')) {
        var match = /((?:%20|\s)+(.*?)(?:s|$))/.exec(this.props.action);
        if (match == null || match.length < 3) return;
        var start = (0, _parseFloat2["default"])(match[2]);
        if (isNaN(start)) return;
        this.videoActionManager.executeAction(_VideoActionManager.ACTION_TYPES.START_VIDEO, start);
      } else if (this.props.action.startsWith('startendvideo')) {
        var regex = /((?:%20|\s)+(.*?)(?:s|$))/g;

        var _match = regex.exec(this.props.action);

        if (_match == null || _match.length < 3) return;

        var _start = (0, _parseFloat2["default"])(_match[2]);

        if (isNaN(_start)) return;
        _match = regex.exec(this.props.action);
        if (_match == null || _match.length < 3) return;
        var end = (0, _parseFloat2["default"])(_match[2]);
        if (isNaN(end)) return;
        if (_start >= end) return;
        this.videoActionManager.executeAction(_VideoActionManager.ACTION_TYPES.STARTEND_VIDEO, _start, end);
      }
    }
  }, {
    key: "_correctProtocol",
    value: function _correctProtocol(url) {
      var protocol = window.location.protocol.toLowerCase();

      if (protocol === 'file:' || protocol === 'https:' || protocol === 'http:') {
        var parts = _UrlHelper["default"].parseURL(url);

        var protocolToUse = protocol === 'file:' ? 'https:' : protocol;
        var host = protocol === 'https:' && parts.host.match(/:80$/) ? parts.host.substring(0, parts.host.length - 3) : protocol === 'http:' && parts.host.match(/:443$/) ? parts.host.substring(0, parts.host.length - 4) : parts.host;
        return protocolToUse + '//' + host + (parts.pathname.substring(0, 1) !== '/' ? '/' : '') + parts.pathname + parts.search + parts.hash;
      }

      return url;
    }
  }, {
    key: "_correctM3u8",
    value: function _correctM3u8(url) {
      if (url && url.match('cdn.equeo.de')) url = url.replace(/cdn.equeo.de/, 'content.jwplatform.com');
      return this._correctProtocol(url);
    }
  }, {
    key: "_correctShareableUrl",
    value: function _correctShareableUrl(url) {
      if (url && url.match('cdn.jwplayer.com')) url = url.replace(/cdn.jwplayer.com/, 'cdn.equeo.de');
      return url;
    }
  }, {
    key: "_correctThumbnail",
    value: function _correctThumbnail(url) {
      if (url && url.match('cdn.equeo.de')) url = url.replace(/cdn.equeo.de/, 'assets-jpcust.jwpsrv.com');
      return this._correctProtocol(url);
    }
  }, {
    key: "checkIsOfflineAvailable",
    value: function () {
      var _checkIsOfflineAvailable = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var offlineAvailable, localSrc, correctedSrc;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return", _promise["default"].resolve(false));

              case 2:
                _context5.prev = 2;
                _context5.next = 5;
                return _CordovaFileHelper["default"].fileExists(this.shortFilename, _CordovaFileHelper.LOCAL_FILENAMES.VIDEO_FOLDER);

              case 5:
                offlineAvailable = _context5.sent;
                _context5.next = 8;
                return _CordovaFileHelper["default"].getFileURL(this.shortFilename, _CordovaFileHelper.LOCAL_FILENAMES.VIDEO_FOLDER, false);

              case 8:
                localSrc = _context5.sent;
                correctedSrc = _config["default"].useLocalhostFiles && _DeviceInfoHelper["default"].isiOS() && window.WkWebView ? window.WkWebView.convertFilePath(localSrc) : localSrc;
                this.setState({
                  offlineAvailable: offlineAvailable,
                  localSrc: correctedSrc
                });
                return _context5.abrupt("return", _promise["default"].resolve(offlineAvailable));

              case 14:
                _context5.prev = 14;
                _context5.t0 = _context5["catch"](2);
                this.setState({
                  offlineAvailable: false
                });
                return _context5.abrupt("return", _promise["default"].resolve(false));

              case 18:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[2, 14]]);
      }));

      function checkIsOfflineAvailable() {
        return _checkIsOfflineAvailable.apply(this, arguments);
      }

      return checkIsOfflineAvailable;
    }()
  }, {
    key: "getNugget",

    /**
     * @return {VideoNugget}
     */
    value: function getNugget() {
      return this.state.content[this.props.id];
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      // default values with ratio 4:3
      var chapterPreviewWidth = 160;
      var chapterPreviewHeight = 120;
      var colCount = -1; // calculate zoom factor

      if (this.videoElement && this.videoElement.offsetWidth > 0) {
        var availWidth = this.videoElement.offsetWidth - 1; // -1 to correct rounding issues in safari where 372.9px will end up as 373px

        colCount = availWidth >= WIDE_ROW_THRESHOLD ? 4 : 2;
        chapterPreviewWidth = availWidth / colCount - (colCount - 1) * 10 / colCount; // MARGIN is 10

        chapterPreviewHeight = 0.75 * chapterPreviewWidth; // ratio 4:3
      }

      return {
        chapterPreview: {
          width: chapterPreviewWidth,
          height: chapterPreviewHeight
        },
        colCount: colCount
      };
    }
  }, {
    key: "initListeners",
    value: function initListeners() {
      _DeviceInfoHelper["default"].addOfflineListener(this.setIsOffline);

      _DeviceInfoHelper["default"].addOnlineListener(this.setIsOnline);
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      document.removeEventListener('offline', this.setIsOffline);
      document.removeEventListener('online', this.setIsOnline);

      if (this.videoElement) {
        this.videoElement.removeEventListener('play', this.onPlay);
        this.videoElement.removeEventListener('pause', this.onPause);
        this.videoElement.removeEventListener('canplaythrough', this.videoElement.play);
      }

      if (this.watchedSequences) this.watchedSequences.postAndUnload();
    }
  }, {
    key: "setProgress",

    /**
     * Instead of setting the progress immediately, this functions only sets the last given progress once a second
     * @param progress
     */
    value: function setProgress(progress) {
      var _this4 = this;

      this.nextDownloadProgressToSet = progress;

      if (!this.progressTimeout) {
        this.progressTimeout = setTimeout(function () {
          _this4.setState({
            downloadProgress: _this4.nextDownloadProgressToSet
          });

          _this4.progressTimeout = null;
        }, this.state.downloadProgress <= 0 ? 0 : 300);
      }
    }
  }, {
    key: "renderFullscreenButton",
    value: function renderFullscreenButton() {
      var nugget = this.getNugget();
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: _config["default"].useTileBackgroundColorInTile && this.props.forcedUIColor ? {
          backgroundColor: this.props.forcedUIColor
        } : {
          backgroundColor: _cssConstants["default"].colors.buttonBackground
        },
        className: "".concat(this.props.inGalleryContainer ? _DrupalVideoNugget["default"].fullscreenButtonSmall : _DrupalVideoNugget["default"].fullscreenButton),
        onClick: this.toggleFullscreen
      }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        className: _DrupalVideoNugget["default"].icon,
        src: FULLSCREEN_ENTER_ICON,
        alt: "fullscreen icon"
      }));
    }
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      var nugget = this.getNugget();
      var caption;
      var iconSrc;
      var action = null;
      var iconBlinks = false;

      var isDownloadable = this.getNugget().downloadable && _config["default"].videosDownloadable;

      if (isDownloadable) {
        if (this.state.isOnline) {
          if (this.isDownloading) {
            iconSrc = _config["default"].loadingIcon ? _config["default"].loadingIcon : DOWNLOAD_ICON;
            iconBlinks = true;

            if (this.state.downloadProgress === 0) {
              caption = (0, _DrupalVideoNuggetStrings.getString)('DOWNLOADING');
            } else if (this.state.downloadProgress >= 100) {
              caption = this.props.inGalleryContainer ? (0, _DrupalVideoNuggetStrings.getString)('SAVING_SHORT') : (0, _DrupalVideoNuggetStrings.getString)('SAVING');
            } else {
              caption = "".concat(this.state.downloadProgress, " %");
            }
          } else {
            if (this.state.offlineAvailable) {
              iconSrc = _config["default"].deleteIcon ? _config["default"].deleteIcon : DELETE_ICON;
              caption = this.props.inGalleryContainer ? (0, _DrupalVideoNuggetStrings.getString)('DELETE_VIDEO_SHORT') : (0, _DrupalVideoNuggetStrings.getString)('DELETE_VIDEO');
              action = this.deleteVideo;
            } else {
              iconSrc = _config["default"].downloadIcon ? _config["default"].downloadIcon : DOWNLOAD_ICON;
              caption = this.props.inGalleryContainer ? (0, _DrupalVideoNuggetStrings.getString)('DOWNLOAD_VIDEO_SHORT') : (0, _DrupalVideoNuggetStrings.getString)('DOWNLOAD_VIDEO');
              action = this.downloadVideo;
            }
          }
        } else if (this.state.offlineAvailable) {
          iconSrc = _config["default"].deleteIcon ? _config["default"].deleteIcon : DELETE_ICON;
          caption = this.props.inGalleryContainer ? (0, _DrupalVideoNuggetStrings.getString)('DELETE_VIDEO_SHORT') : (0, _DrupalVideoNuggetStrings.getString)('DELETE_VIDEO');
          action = this.deleteVideo;
        } else {
          iconSrc = _config["default"].errorIcon ? _config["default"].errorIcon : ERROR_ICON;
          caption = this.props.inGalleryContainer ? (0, _DrupalVideoNuggetStrings.getString)('YOU_ARE_OFFLINE_SHORT') : (0, _DrupalVideoNuggetStrings.getString)('YOU_ARE_OFFLINE');
          action = null;
        }
      }

      var iconClassnames = "".concat(_DrupalVideoNugget["default"].icon, " ").concat(iconBlinks ? _DrupalVideoNugget["default"].blink : '');
      var posterPath = null;

      if (nugget.thumbnail) {
        if (_DeviceInfoHelper["default"].isBrowser() || nugget.thumbnail.startsWith('http://') || nugget.thumbnail.startsWith('https://') || nugget.thumbnail.startsWith('data:')) {
          posterPath = this._correctThumbnail(nugget.thumbnail);
        } else {
          posterPath = "".concat(this.props.path).concat(nugget.thumbnail);
        }
      }

      var options = {
        message: nugget.title,
        // not supported on some apps (Facebook, Instagram)
        subject: nugget.title,
        // fi. for email
        files: [posterPath],
        // an array of filenames either locally or remotely
        url: this._correctShareableUrl(this.state.sanitizedSrc || nugget.src),
        chooserTitle: 'Wähle eine App zum Teilen:' // Android only, you can override the default share sheet title

      };

      var onError = function onError(msg) {
        return console.log('Sharing failed with message: ' + msg);
      };

      var onSuccess = function onSuccess(msg) {
        return console.log('Sharing successful with message: ' + msg);
      };

      var onShare = function onShare() {
        return window.plugins.socialsharing.shareWithOptions(options, onSuccess, onError);
      };

      if (this.props.inGalleryContainer) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalVideoNugget["default"].doubleButtonContainer
        }, isDownloadable && /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalVideoNugget["default"].leftButton,
          style: _config["default"].useTileBackgroundColorInTile && this.props.forcedUIColor ? {
            backgroundColor: this.props.forcedUIColor
          } : {
            backgroundColor: _cssConstants["default"].colors.buttonBackground
          },
          onClick: action
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: _DrupalVideoNugget["default"].caption
        }, caption), /*#__PURE__*/_react["default"].createElement(_Image["default"], {
          className: iconClassnames,
          src: iconSrc,
          alt: "download status icon"
        })), nugget.canShare && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalVideoNugget["default"].rightButton,
          style: _config["default"].useTileBackgroundColorInTile && this.props.forcedUIColor ? {
            backgroundColor: this.props.forcedUIColor
          } : {
            backgroundColor: _cssConstants["default"].colors.buttonBackground
          },
          onClick: onShare
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: _DrupalVideoNugget["default"].caption
        }, 'Share'), /*#__PURE__*/_react["default"].createElement(_Image["default"], {
          className: iconClassnames,
          src: SHARE_ICON,
          alt: "share icon"
        }))));
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalVideoNugget["default"].doubleButtonContainer
      }, isDownloadable && /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalVideoNugget["default"].leftButton,
        style: _config["default"].useTileBackgroundColorInTile && this.props.forcedUIColor ? {
          backgroundColor: this.props.forcedUIColor
        } : {
          backgroundColor: _cssConstants["default"].colors.buttonBackground
        },
        onClick: action
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _DrupalVideoNugget["default"].caption
      }, caption), /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        className: iconClassnames,
        src: iconSrc,
        alt: "download status icon"
      })), nugget.canShare && /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalVideoNugget["default"].rightButton,
        style: _config["default"].useTileBackgroundColorInTile && this.props.forcedUIColor ? {
          backgroundColor: this.props.forcedUIColor
        } : {
          backgroundColor: _cssConstants["default"].colors.buttonBackground
        },
        onClick: onShare
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _DrupalVideoNugget["default"].caption
      }, 'Video teilen'), /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        className: iconClassnames,
        src: SHARE_ICON,
        alt: "share icon"
      })));
    }
  }, {
    key: "renderChapter",
    value: function renderChapter(chapter, index) {
      var _this5 = this;

      var playChapter = function playChapter() {
        if (_this5.watchedSequences) _this5.watchedSequences.addChapter(chapter.caption);

        if (_this5.videoElement) {
          _this5.videoElement.pause();

          _this5.videoElement.currentTime = chapter.start;

          _this5.videoElement.play();
        }
      };

      var styleAndMetadata = this.getStyle();

      if (_config["default"].renderVideoChapterAsList) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: "chapter_".concat(index),
          className: _DrupalVideoNugget["default"].lineChapter,
          onClick: function onClick() {
            return _this5.setState({
              videoIsPlaying: true
            }, function () {
              return playChapter();
            });
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalVideoNugget["default"].lineText
        }, chapter.caption), /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalVideoNugget["default"].lineTime,
          style: {
            color: _cssConstants["default"].colors.primaryColor1
          }
        }, "(".concat(_StringHelper["default"].getHumanReadableTimeString(chapter.start), ")")));
      } else {
        var spritePath = _DeviceInfoHelper["default"].isBrowser() ? chapter.sprite : "".concat(this.props.path).concat(chapter.sprite);
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: "chapter_".concat(index),
          className: "".concat(_DrupalVideoNugget["default"].chapterPreview, " ").concat(styleAndMetadata.colCount === 2 && (index + 1) % 2 === 0 ? _DrupalVideoNugget["default"].second : '', "  ").concat((index + 1) % 4 === 0 ? _DrupalVideoNugget["default"].fourth : ''),
          style: styleAndMetadata.chapterPreview
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalVideoNugget["default"].chapter,
          style: {
            backgroundImage: "url(".concat(spritePath, ")")
          },
          onClick: onClick
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalVideoNugget["default"].timeWrapper
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalVideoNugget["default"].time
        }, _StringHelper["default"].getHumanReadableTimeString(chapter.start)), /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalVideoNugget["default"].text
        }, chapter.caption))));
      }
    }
  }, {
    key: "renderChapters",
    value: function renderChapters() {
      var _this6 = this;

      var chapters = this.getNugget().chapters;
      if (!chapters) return;
      var renderedChapters = chapters.map(function (chapter, index) {
        return _this6.renderChapter(chapter, index);
      });
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalVideoNugget["default"].chapterCaption
      }, (0, _DrupalVideoNuggetStrings.getString)('CHOOSE_CHAPTER')), /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalVideoNugget["default"].chapters
      }, renderedChapters));
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var nugget = this.getNugget();
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var src;

      if (this.state.offlineAvailable) {
        src = this.state.localSrc;
      } else if (this.state.playsM3u8) {
        src = this.state.sanitizedM3u8;
      } else {
        src = this.state.sanitizedSrc;
      }

      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';
      var posterPath = null;

      if (nugget.thumbnail) {
        if (_DeviceInfoHelper["default"].isBrowser() || nugget.thumbnail.startsWith('http://') || nugget.thumbnail.startsWith('https://') || nugget.thumbnail.startsWith('data:')) {
          posterPath = this._correctThumbnail(nugget.thumbnail);
        } else {
          posterPath = "".concat(this.props.path).concat(nugget.thumbnail);
        }
      }

      var likes = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_LIKES) || [];
      var likeIndex = likes.indexOf(this.props.id);
      var allLikes = this.state.data[_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES];
      var currentLikesForId = allLikes && allLikes["".concat(this.props.id)] ? allLikes["".concat(this.props.id)] : 0;

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      var buttonColor = _config["default"].isErgoApp && _cssConstants["default"].colors.ergoRed || _config["default"].useTileBackgroundColorInTile && this.props.forcedUIColor || _cssConstants["default"].colors.videoButtonBackground || _cssConstants["default"].colors.buttonBackground;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "videoContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons ? this.props.renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "VideoNugget_".concat(this.props.id, " ").concat(_Nugget["default"].container, " ").concat(innerClassNames)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(nugget.theme, " videodiv ").concat(_DrupalVideoNugget["default"].videodiv, " ").concat(nugget.title && nugget.show_title ? '' : 'extraPadding')
      }, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), nugget.show_title && (_config["default"].targetTag !== "visitberlin" ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(this.props.inGalleryContainer ? 'titleSmall' : 'title')
      }, nugget.title) : /*#__PURE__*/_react["default"].createElement("h1", {
        className: this.props.inGalleryContainer ? 'titleSmall' : 'title'
      }, nugget.title)), this.state.videoIsPlaying && src ? /*#__PURE__*/_react["default"].createElement(_Video["default"], {
        autoPlay: true,
        controls: true,
        controlsList: 'nodownload',
        videoId: this.domId,
        src: src,
        onLoadedMetadata: this.onMetadataLoaded,
        poster: posterPath,
        preload: 'none',
        playsInline: this.props.inGalleryContainer,
        subtitles: this.state.subtitleUrl,
        tabIndex: 0
      }) : /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'relative'
        }
      }, _config["default"].useOpacPlayIconInVideoNugget ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        src: require('./assets/play-button.svg'),
        alt: "play button",
        tabIndex: 0,
        id: 'playBtn',
        className: 'doNotInvert',
        onClick: function onClick() {
          return _this7.setState({
            videoIsPlaying: true
          });
        },
        style: {
          opacity: 0.8,
          position: 'absolute',
          left: '50%',
          top: '50%',
          width: '50%',
          height: '50%',
          transform: 'translate(-50%, -50%)'
        }
      }), /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: "Posterbild des Videos",
        src: posterPath,
        onClick: function onClick() {
          return _this7.setState({
            videoIsPlaying: true
          });
        }
      })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_PlayCircleFilled["default"], {
        tabIndex: 0,
        alt: "play button",
        id: 'playBtn',
        className: 'doNotInvert',
        onClick: function onClick() {
          return _this7.setState({
            videoIsPlaying: true
          });
        },
        style: {
          color: buttonColor,
          position: 'absolute',
          left: '50%',
          top: '50%',
          width: '50%',
          height: '50%',
          transform: 'translate(-50%, -50%)'
        }
      }), /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: "Posterbild des Videos",
        src: posterPath,
        onClick: function onClick() {
          return _this7.setState({
            videoIsPlaying: true
          });
        }
      }))), nugget.info ? /*#__PURE__*/_react["default"].createElement("p", {
        dangerouslySetInnerHTML: {
          __html: nugget.info
        }
      }) : null, nugget.transcript ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalVideoNugget["default"].transcriptContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalVideoNugget["default"].transcriptTitle,
        onClick: function onClick() {
          return _this7.toogleTranscript();
        }
      }, "Transkript zum Video", ' ', this.state.transcriptOpen ? /*#__PURE__*/_react["default"].createElement(_icons.ArrowDropDown, {
        className: _DrupalVideoNugget["default"].transcriptArrow
      }) : /*#__PURE__*/_react["default"].createElement(_icons.ArrowRight, {
        className: _DrupalVideoNugget["default"].transcriptArrow
      })), this.state.transcriptOpen ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalVideoNugget["default"].transcriptText,
        dangerouslySetInnerHTML: {
          __html: nugget.transcript
        }
      }) : null) : null, this.renderChapters())), !_DeviceInfoHelper["default"].isBrowser() && (nugget.downloadable && _config["default"].videosDownloadable || nugget.canShare) && /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.inGalleryContainer ? _DrupalVideoNugget["default"].videoButtonsSmall : _DrupalVideoNugget["default"].videoButtons
      }, this.renderButtons()), _config["default"].hasLikeFunctionalityForNuggets && !this.props.inSwipeContainer && !this.props.inListContainer && !this.props.inGalleryContainer ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeContainer
      }, _config["default"].useTargetIcons ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        className: _Nugget["default"].svgLikeButton,
        onClick: function onClick() {
          return _this7.props.setLike();
        },
        src: likeIndex < 0 ? _config["default"].likeInactive : _config["default"].likeActive,
        alt: "like button"
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        onClick: function onClick() {
          return _this7.props.setLike();
        },
        className: likeIndex < 0 ? _Nugget["default"].likeButton : _Nugget["default"].likeButtonActivated,
        name: 'thumbs-o-up',
        alt: "like button"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeText
      }, "".concat(currentLikesForId, " ").concat(currentLikesForId === 1 ? 'Like' : 'Likes'))) : null);
    }
  }]);
  return DrupalVideoNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalVideoNugget;
DrupalVideoNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  showControls: _propTypes["default"].bool,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  forcedUIColor: _propTypes["default"].string,
  renderIcon: _propTypes["default"].func.isRequired,
  galleryContainerIndex: _propTypes["default"].number,
  setLike: _propTypes["default"].func
};
DrupalVideoNugget.defaultProps = {
  id: null,
  showControls: true,
  galleryContainerIndex: 100
};